export const APP_ROUTE_PATH = "/apps/:appId";
export const SECTION_ROUTE_PATH = "/apps/:appId/:questionnaireId/:sectionId";
export const SECTION_OVERVIEW_ROUTE_PATH = "/apps/:appId/:questionnaireId";

export const FULL_OPTIONAL_PATH = "/apps/:appId?/:questionnaireId?/:sectionId?";
